<template>
  <div class="sm:col-span-9">
    <div class="space-y-3">
      <div class="grid grid-cols-12 gap-2">
        <slot></slot>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
  import { defineComponent } from 'vue'

  export default defineComponent({
    name: 'FormGrid'
  })
</script>
